import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import {
    createColumnHelper,
    getCoreRowModel,
    useReactTable
} from '@tanstack/react-table'
import { ReactComponent as IconDeleteProduct } from '../../assets/images/icons/icon-delete.svg'
import TableListing from '../../components/TableListing/TableListing'
import { ReactComponent as IconsDots } from '../../assets/images/icons/icon-action-dots.svg'
import { ReactComponent as IconView } from '../../assets/images/icons/icon-view-white.svg'
import { ReactComponent as IconDelete } from '../../assets/images/icons/icon-delete-white.svg'
import { ReactComponent as IconRejected } from '../../assets/images/icons/icon-rejected-status.svg'
import { ReactComponent as IconRejectedLabel } from '../../assets/images/icons/icon-rejected-red.svg'
import requestApi from '../../utils/request'
import TableSkeleton from '../../components/TableSkeleton/TableSkeleton'
import { useForm } from 'react-hook-form'
import PaginationItem from '../../components/Pagination/Pagination'
import { designerview, productcatalog } from '../../config/routingConsts'
import ImageZoomModal from '../../components/ImageZoomModal/ImageZoomModal'
import ApproveDeclinePopup from '../../components/ApproveDeclinePopup/ApproveDeclinePopup'
import Swal from 'sweetalert2'
import DeleteModal from '../../components/DeleteModal/DeleteModal'
import { currencyFormateForRuppe, customFilter } from '../../functions/common'

//#region  API Call for view Vendor Data
const vendorViewDetail = async (catalogId) => {
    return await requestApi
        .post(`/catalog/view`, { catalogId }, { headers: true })
        .then((res) => {
            return res.data
        })
}
//#endregion

const ViewProductDetails = () => {
    const { state } = useLocation()

    const queryClient = useQueryClient()
    const EditDataRef = useRef(null)

    const [noteText, setnoteText] = useState('')

    // for Approve/Decline Popup States

    const [ShowMaterialStatusPopup, setShowMaterialStatusPopup] =
        useState(false)
    const [statusUpdate, setStatusUpdate] = useState(null)
    const [buttonText, setButtonText] = useState('')

    const [isDeleteModal, setIsDeleteModal] = useState(false)
    const [deleteId, setDelteId] = useState('')

    const [imageShow, setImageShow] = useState(false)
    const [imageGet, setImageGet] = useState(null)
    const [DataLimit, setDataLimit] = useState(10)
    const [currentPage, setCurrentPage] = useState(1)
    const [searchKeyword, setSearchKeyword] = useState()
    const { catalogId, productId } = useParams()
    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm()
    const navigate = useNavigate()

    const { data, isLoading } = useQuery({
        queryKey: ['vendor-view', currentPage, DataLimit, searchKeyword],
        queryFn: () => vendorViewDetail(catalogId),
        enabled: !!catalogId,
        onSuccess: (data) => {
            // reset({
            //     size:data?.data?.name
            // })
        },
        onError: (error) => {
            console.log(error.message)
        }
    })

    const handleSearch = useCallback((e) => {
        setCurrentPage(1)
    //    const a= customFilter(data?.data?.addVariant,e.target.value,["size","color"])
    //    console.log({a},"test")
        const getData = setTimeout(() => {
            setSearchKeyword(e.target.value)
        }, 1000)
        clearInterval()
       
    }, [data])

    const handleChangePage = useCallback(
        (currentPage) => {
            setCurrentPage(currentPage)
        },
        [currentPage]
    )
    const handleChange = (eventkey) => {
        setDataLimit(eventkey)
    }

    useEffect(() => {
        if (currentPage && data?.data?.addVariant?.length == 0) {
            setCurrentPage(currentPage - 1)
        } else {
        }
    }, [currentPage, data?.data?.addVariant])

    const [openAction, setopenAction] = useState(null)
    const OpenAction = (id) => {
        setopenAction(openAction === id ? null : id)
    }

    const handleImageZoomModal = (imagePath) => {
        setImageShow(true)
        setImageGet(imagePath)
    }

    //#region  Min- Max Selling Price
    function SellingPriceMinMax(items) {
        const priceData = items.reduce(
            (acc, variant) => {
                if (variant.sellingPrice < acc.minSellingPrice) {
                    acc.minSellingPrice = variant.sellingPrice
                }
                if (variant.sellingPrice > acc.maxSellingPrice) {
                    acc.maxSellingPrice = variant.sellingPrice
                }
                return acc
            },
            { minSellingPrice: Infinity, maxSellingPrice: -Infinity }
        )

        const minSellingPrice = priceData.minSellingPrice
        const maxSellingPrice = priceData.maxSellingPrice

        return { minSellingPrice, maxSellingPrice }
    }
    //#endregion

    //#region Table Headers
    const columnHelper = createColumnHelper()
    const columns = [
        columnHelper.accessor((row) => row.VariantPhotos, {
            id: 'VariantPhotos',
            enableSorting: false,
            header: () => 'Variant Photos',
            cell: (row) => {
                return (
                    <>
                        <div className="product-thumbnail">
                            <img
                                src={
                                    row?.row?.original?.productImages[0].image
                                        ? row?.row?.original?.productImages[0]
                                              .image
                                        : '-'
                                }
                                alt="product-image"
                                onClick={() =>
                                    handleImageZoomModal(
                                        row?.row?.original?.productImages
                                    )
                                }
                            />
                        </div>
                    </>
                )
            }
        }),
        columnHelper.accessor((row) => row?.color, {
            id: 'color',
            header: () => 'Color',
            enableSorting: false,
            cell: (row) => {
                return (
                    <>
                        <span className="label-badge-title">
                            {row?.row?.original?.color}
                            {row?.row?.original?.colorStatus === 7 && (
                                <span
                                    className="label-badge"
                                    onClick={() =>
                                        handleApproveDecline(
                                            row?.row?.original?.colorId,
                                            setButtonText('Approve')
                                        )
                                    }
                                >
                                    New Color
                                </span>
                            )}
                        </span>
                    </>
                )
            }
        }),
        columnHelper.accessor((row) => row?.Size, {
            id: 'Size',
            header: () => 'Size',
            enableSorting: false,
            cell: (row) => {
                return (
                    <>
                        <span className="multi-size">
                            {row?.row?.original?.variantList?.map((list, i) => {
                                return (
                                    <React.Fragment key={i}>
                                        <span>{list?.size}</span>
                                        {list?.size?.length > 0 && (
                                            <span> ,</span>
                                        )}
                                    </React.Fragment>
                                )
                            })}
                        </span>
                    </>
                )
            }
        }),
        columnHelper.accessor((row) => row?.TotalAvailableQty, {
            id: 'TotalAvailableQty',
            header: () => 'Total Available Qty',
            enableSorting: false,
            cell: (row) => {
                return (
                    <>
                        <span>
                            {row?.row?.original?.variantList?.reduce(
                                (total, list) =>
                                    total + (list.availableQty || 0),
                                0
                            )}
                        </span>
                    </>
                )
            }
        }),
        columnHelper.accessor((row) => row?.PriceRange, {
            id: 'PriceRange',
            header: () => 'Price Range (₹)',
            enableSorting: false,
            cell: (row) => {
                const { minSellingPrice, maxSellingPrice } = SellingPriceMinMax(
                    row?.row?.original.variantList
                )
                return (
                    <p>
                        <b>{`${currencyFormateForRuppe(
                            minSellingPrice
                        )}  -  ${currencyFormateForRuppe(maxSellingPrice)}`}</b>
                    </p>
                )
            }
        }),
        columnHelper.accessor((row) => row?.Status, {
            id: 'Status',
            header: () => 'Status',
            enableSorting: false,
            cell: (row) => {
                return (
                    <>
                        <label className="switch">
                            <input
                                type="checkbox"
                                checked={
                                    row?.row?.original?.status == 1
                                        ? true
                                        : false
                                }
                                onChange={(e) =>
                                    onStatusChange(
                                        row?.row?.original?.variantId,
                                        row?.row?.original?.status
                                    )
                                }
                            />
                            <span className="slider round"></span>
                        </label>
                    </>
                )
            }
        }),
        columnHelper.display({
            id: 'Action',
            header: () => 'Action',
            cell: (row) => {
                return (
                    <>
                        <div
                            className={`table-action ${
                                row?.row?.original?.variantId === openAction
                                    ? 'active'
                                    : ''
                            }`}
                            onMouseLeave={() => setopenAction(null)}
                        >
                            <div
                                className={`action-btn ${
                                    row?.row?.original?.variantId === openAction
                                        ? 'active'
                                        : ''
                                }`}
                                onClick={() =>
                                    OpenAction(row?.row?.original?.variantId)
                                }
                            >
                                <IconsDots />
                            </div>
                            <div className="action-panel two-action">
                                <div
                                    className="action-btn-icon view"
                                    onClick={() =>
                                        navigate(
                                            `${productcatalog}/${catalogId}/${row?.row?.original?.variantId}`
                                        )
                                    }
                                >
                                    <IconView />
                                </div>
                                <div
                                    className="action-btn-icon delete"
                                    onClick={() =>
                                        handleDeleteModalForVariant(
                                            row?.row?.original?.variantId
                                        )
                                    }
                                >
                                    <IconDelete />
                                </div>
                            </div>
                        </div>
                    </>
                )
            }
        })
    ]

    //#endregion

    const table = useReactTable({
        data: data?.data?.addVariant || [],
        columns: columns,
        // createColumnHelper : getCreateColumnHelper(),
        // onSortingChange: setSorting,
        // getSortedRowModel: getSortedRowModel(),
        getCoreRowModel: getCoreRowModel()
    })

    //#region  Approve material Process
    const handleApproveDecline = (id) => {
        setShowMaterialStatusPopup(true)
        setStatusUpdate(id)
    }

    function handlePermission(Id) {
        mutationStatusUpdate.mutate(Id)
        setShowMaterialStatusPopup(false)
    }

    async function updateStatusbyId(Id) {
        switch (buttonText) {
            case 'Approve':
                return await requestApi.post(`/color/approve-decline`, {
                    colorId: Id,
                    status: 1
                })

            case 'Decline':
                return await requestApi.post(`/color/approve-decline`, {
                    colorId: Id,
                    status: 5
                })

            // case 'Approve Product':
            //     return await requestApi.post(`/catalog/approve-decline`, {
            //         catalogId: Id,
            //         status: 1
            //     })

            // case 'Decline Product':
            //     return await requestApi.post(`/catalog/approve-decline`, {
            //         catalogId: Id,
            //         status: 5,
            //         note:noteText
            //     })
        }
    }

    const mutationStatusUpdate = useMutation(updateStatusbyId, {
        onSuccess: (data) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: '',
                text: data?.meta?.message
            })
            queryClient.invalidateQueries('variantlist')
            setShowMaterialStatusPopup(false)
        },
        onError: (error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                text: error?.message
            })
        }
    })
    //#endregion

    //#region Handle Status
    function statusCaseHandle(datas) {
        switch (datas?.status) {
            case 1:
                return (
                    <div
                        className="delete-btn"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Delete"
                        onClick={() => handleDeleteModal(datas?.id)}
                    >
                        <IconDeleteProduct />
                    </div>
                )
            case 7:
                return (
                    <>
                        <div className="search-btn-group">
                            {/* <span
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Accept"
                                style={{ cursor: 'pointer' }}
                                onClick={() =>
                                    handleApproveDecline(
                                        datas?.id,
                                        setButtonText('Approve Product')
                                    )
                                }
                            >
                                <AcceptLogo />
                            </span>
                            <span
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Decline"
                                style={{ cursor: 'pointer' }}
                                onClick={() =>
                                    handleApproveDecline(
                                        datas?.id,
                                        setButtonText('Decline Product')
                                    )
                                }
                            >
                                <DeclineLogo />
                            </span> */}
                        </div>
                    </>
                )
            case 5:
                return (
                    <div
                        className="delete-btn"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Rejected"
                        // style={{pointerEvents:"none"}}
                    >
                        <IconRejected />
                    </div>
                )
            default:
                return null
        }
    }
    //#endregion

    //#region  Delete Modal for Catalog Delete
    const handleDeleteModal = (id) => {
        setIsDeleteModal(true)
        setDelteId(id)
    }

    function handleDelete(catalogId) {
        mutationDelete.mutate(catalogId)
        setIsDeleteModal(false)
    }

    async function deleteCatalogId(catalogId) {
        return await requestApi.post(`catalog/delete`, {
            catalogId
        })
    }

    const mutationDelete = useMutation(deleteCatalogId, {
        onSuccess: ({ data }) => {
            queryClient.invalidateQueries('cataloglist')
            setIsDeleteModal(false)
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: '',
                allowOutsideClick: false,
                text: data?.meta?.message
            })
            navigate(productcatalog)
            EditDataRef.current = null
        },
        onError: (error) => {
            EditDataRef.current = null
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                allowOutsideClick: false,
                text: error?.message
            })
        }
    })
    //#endregion

    //#region  Active/InActive Status Update
    const onStatusChange = useCallback((variantId, currentStatus) => {
        mutationStatusActiveInactive.mutate({ variantId, currentStatus })
    }, [])
    async function updateStatusbyvariantId(variant) {
        const { variantId, currentStatus } = variant
        return await requestApi.post(`/catalog/variant/active-Inactive`, {
            variantId: variantId,
            catalogId: catalogId,
            status: currentStatus
        })
    }
    const mutationStatusActiveInactive = useMutation(updateStatusbyvariantId, {
        onSuccess: ({ data }) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: '',
                text: data?.meta?.message
            })
            queryClient.invalidateQueries('vendor-view')
            setShowMaterialStatusPopup(false)
        },
        onError: (error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                text: error?.message
            })
        }
    })
    //#endregion

        //#region  Delete Modal for Variant Delete
        const handleDeleteModalForVariant = (id) => {
            setIsDeleteModal(true)
            setDelteId(id)
        }
    
        function handleDelete(variantId) {
            mutationDeleteVariant.mutate(variantId)
            setIsDeleteModal(false)
        }
    
        async function deleteVariant(variantId) {
            return await requestApi.post(`catalog/delete`, {
                variantId,
                catalogId
            })
        }
    
        const mutationDeleteVariant = useMutation(deleteVariant, {
            onSuccess: ({ data }) => {
                queryClient.invalidateQueries('cataloglist')
                setIsDeleteModal(false)
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: '',
                    allowOutsideClick: false,
                    text: data?.meta?.message
                })
                navigate(productcatalog)
                EditDataRef.current = null
            },
            onError: (error) => {
                EditDataRef.current = null
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: '',
                    allowOutsideClick: false,
                    text: error?.message
                })
            }
        })
        //#endregion

    return (
        <>
            <div className="view-product-details">
                <ul className="site-breadcrumb">
                    {console.log(state,"state")}
                    {state == 'designerview' && (
                        <li>
                            <Link to={designerview}>Designer Detail</Link>
                        </li>
                    )}
                    {
                        state !== "designerview"  &&
                    <li>
                        <Link to={productcatalog}>Product Management</Link>
                    </li>
                    }
                    <li>Product Detail</li>
                </ul>
                <div className="admin-card">
                    <div className="head">
                        <h2>Product Detail</h2>

                        {/* Changes Icons dependes on Status */}
                        {statusCaseHandle(data?.data)}

                        {/* <div className="delete-btn">
                            <IconDeleteProduct />
                        </div> */}
                    </div>
                </div>
                {data?.data?.status === 5 ? (
                    <>
                        <div className="rejected-label">
                            <IconRejectedLabel />
                            <div>
                                <h6>Rejected</h6>
                                {data?.data?.reason && <p><b>Reason: </b> {data?.data?.reason}</p>}
                                {data?.data?.note && <p><b>Note: </b> {data?.data?.note}</p>} 
                                {data?.data?.sellerNo && <p>Please contact supplier support. <b>+91 {data?.data?.sellerNo}</b> </p>}
                            </div>
                        </div>
                    </>
                ) : (
                    <></>
                )}

                <div className="admin-card product-details-card">
                    <div className="card-head">
                        <h6>
                            {data?.data?.productName
                                ? data?.data?.productName
                                : '-'}
                        </h6>
                    </div>
                    <div className="product-list-group">
                        <ul className="product-details-list">
                            <li>
                                <span>Product ID</span>
                                {data?.data?.productUniqueId
                                    ? data?.data?.productUniqueId
                                    : '-'}
                            </li>
                            <li>
                                <span>Designer Name</span>
                                {data?.data?.sellerName ? (
                                    <Link
                                        to={`${designerview}/${data?.data?.sellerId}`}
                                        title="Designer"
                                    >
                                        {data?.data?.sellerName}
                                    </Link>
                                ) : (
                                    '-'
                                )}
                            </li>
                            <li>
                                <span>Category</span>
                                {data?.data?.mainCategoryName
                                    ? data?.data?.mainCategoryName
                                    : '-'}
                                {data?.data?.mainCategoryStatus === 7 && (
                                    <span className="label-badge">New</span>
                                )}
                            </li>
                            <li>
                                <span>Sub Category</span>
                                {data?.data?.categoryName
                                    ? data?.data?.categoryName
                                    : '-'}
                                {data?.data?.categoryStatus === 7 && (
                                    <span className="label-badge">New</span>
                                )}
                            </li>
                            <li>
                                <span>Type</span>
                                {data?.data?.type ? data?.data?.type : '-'}
                                {data?.data?.typeStatus === 7 && (
                                    <span className="label-badge">New</span>
                                )}
                            </li>
                        </ul>
                        <ul className="product-details-list">
                            <li>
                                <span>Country of origin</span>
                                {data?.data?.countryName
                                    ? data?.data?.countryName
                                    : '-'}
                            </li>
                            <li>
                                <span>GST%</span>
                                {data?.data?.gst ? data?.data?.gst : '-'}
                            </li>
                            <li>
                                <span>Material</span>
                                <p className="label-badge=status">
                                    {data?.data?.materialName
                                        ? data?.data?.materialName
                                        : '-'}
                                    {data?.data?.materialStatus === 7 && (
                                        <span className="label-badge">New</span>
                                    )}
                                </p>
                            </li>
                            <li>
                                <span>Weight(gms)</span>
                                {data?.data?.productWeight
                                    ? data?.data?.productWeight
                                    : '-'}
                            </li>
                            <li>
                                <span>Estimated Time</span>
                                {data?.data?.shippingTime
                                    ? data?.data?.shippingTime
                                    : '-'}
                            </li>
                        </ul>
                        <ul className="product-details-list">
                            <li>
                                <span>Description</span>
                                {data?.data?.description
                                    ? data?.data?.description
                                    : '-'}
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="admin-card">
                    <div className="head">
                        <h2>Product Variants</h2>
                        <div className="search-btn-group">
                            <form
                                className="product-table-filter"
                                {...register('productVariants', {
                                    onChange: (e) => {
                                        handleSearch(e)
                                    }
                                })}
                            >
                                <input
                                    type="search"
                                    name="productVariants"
                                    placeholder="Search Variant"
                                />
                            </form>
                        </div>
                    </div>
                    {isLoading ? (
                        <TableSkeleton />
                    ) : data?.data?.addVariant?.length > 0 ? (
                        <>
                            <TableListing
                                table={table}
                                className="m-0"
                                parentLink={`${productcatalog}/${catalogId}`}
                                keyValue="variantId"
                                isLink
                                excludes={[
                                    'Action',
                                    'color',
                                    'Status',
                                    'VariantPhotos'
                                ]}
                                // getfilter={(e) => {setfilter(e)}}
                            />
                            {/* pagination section */}
                            <div className="pagination-wrap">
                                <div className="showing-pages">
                                    <span>
                                        Showing{' '}
                                        {(currentPage - 1) * DataLimit + 1} to{' '}
                                        {Math.min(
                                            currentPage * DataLimit,
                                            data?.data?.addVariant?.length
                                        )}{' '}
                                        of {data?.data?.addVariant?.length}{' '}
                                        Product {data?.data?.addVariant?.length>1 ?"Variants":"Variant"}
                                    </span>
                                </div>
                                {data?.data?.addVariant?.length > 10 && (
                                    <>
                                        {/* <div className="itemperpage-box">
                            <span>Items per page:</span>

                            <Dropdown onSelect={handleChange}>
                                <Dropdown.Toggle
                                    variant="success"
                                    id="dropdown-basic"
                                >
                                    {DataLimit}
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item eventKey="10">
                                        10
                                    </Dropdown.Item>
                                    <Dropdown.Item eventKey="20">
                                        20
                                    </Dropdown.Item>
                                    <Dropdown.Item eventKey="30">
                                        30
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div> */}

                                        <PaginationItem
                                            total={Math.ceil(
                                                data.addVariant.length /
                                                    DataLimit
                                            )}
                                            current={currentPage}
                                            onChangePage={handleChangePage}
                                        />
                                    </>
                                )}
                            </div>
                        </>
                    ) : (
                        <div className="no-record-found">No Record Found</div>
                    )}
                </div>
            </div>
            <ImageZoomModal
                imageShow={imageShow}
                setImageShow={setImageShow}
                imageGet={imageGet}
            />
            <ApproveDeclinePopup
                ShowMaterialStatusPopup={ShowMaterialStatusPopup}
                setShowMaterialStatusPopup={setShowMaterialStatusPopup}
                setStatusUpdate={statusUpdate}
                title={`Are you sure you want to ${buttonText} ?`}
                // handlestatus={handlestatus}
                text={
                    buttonText
                    // buttonText ==="Approve Catalog" ? "Approve":"Decline Catalog"?'Decline':"Approve"?"Approve":"Decline"
                }
                noteText={noteText}
                setnoteText={setnoteText}
                handlePermission={(e) => handlePermission(statusUpdate)}
            />

            <DeleteModal
                message={
                    <>
                        Are you sure you want to <br /> Delete this Product ?
                    </>
                }
                setIsDeleteModal={setIsDeleteModal}
                isDeleteModal={isDeleteModal}
                handleDelete={() => handleDelete(deleteId)}
            />
        </>
    )
}

export default ViewProductDetails
